import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AgrPageDetailModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';

import { EnvironmentalImpactQuickViewComponent } from './components/environmental-impact-quick-view.component';
import { EnvironmentalImpactEffects } from './store/environmental-impact.effects';

@NgModule({
  declarations: [EnvironmentalImpactQuickViewComponent],
  imports: [
    CommonModule,
    AgrPageDetailModule,
    AgrI18nSharedModule,
    LetDirective,
    PushPipe,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  providers: [provideEffects(EnvironmentalImpactEffects)],
  exports: [EnvironmentalImpactQuickViewComponent],
})
export class EnvironmentalImpactModule {}
